import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider, theme } from "@chakra-ui/react";
import App from "./App";

import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./api/apiToken";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

// Register the Firebase Messaging service worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {})
    .catch((error) => {});
}

const renderApp = () =>
  root.render(
    <MsalProvider instance={msalInstance}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </MsalProvider>
  );

// MsalProvider initializes MSAL and processes a login redirect in an effect, which runs
// after the effects of the page it wraps. Pages that call the gateway on mount would ask
// for a token before MSAL is ready and never retry: the status change and TDO forms
// (core/forms/formsAPI through expressAPI) and the termination form
// (hub/manual/paths/invoke through API). MsalProvider's own calls then reuse these
// results. If MSAL fails to start, render anyway so the login flow can surface the
// error instead of a blank page.
msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .catch((error) => console.error("MSAL failed to start:", error))
  .then(renderApp);
